import { render, staticRenderFns } from "./HomeNewProducts.vue?vue&type=template&id=3ff7bc05&scoped=true&"
import script from "./HomeNewProducts.vue?vue&type=script&lang=js&"
export * from "./HomeNewProducts.vue?vue&type=script&lang=js&"
import style0 from "./HomeNewProducts.vue?vue&type=style&index=0&id=3ff7bc05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff7bc05",
  null
  
)

export default component.exports